/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Dubbing_DescInputs */



/**
* | output |
* | --- |
* | "Export dubbed audio mixed over the background stem" |
*
* @param {File_Export_Audio_Dubbing_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_dubbing_desc = /** @type {((inputs?: File_Export_Audio_Dubbing_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Dubbing_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter l'audio doublé mixé sur le stem d'arrière-plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierten Ton über den Hintergrund-Stem gemischt exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta l'audio doppiato mixato sullo stem di sottofondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт дублированного звука, сведённого с фоновым стемом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar el audio doblado mezclado sobre el stem de fondo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出混合在背景音轨上的配音音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックグラウンドステムにミックスした吹き替え音声をエクスポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकग्राउंड स्टेम पर मिक्स किया गया डब ऑडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar o áudio dobrado misturado sobre o stem de fundo")
	return /** @type {LocalizedString} */ ("Export dubbed audio mixed over the background stem")
});